import React from "react";
import styled from "styled-components";

const LoaderWrapper = styled.div`
  margin: auto;
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  width: 32px;
  height: 32px;
`;

const Img = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
`;

function LoadingBar() {
  return (
    <>
      <LoaderWrapper>
        <Img src="/loading_mix.gif" alt="loading gif" />
      </LoaderWrapper>
    </>
  );
}

export default LoadingBar;
